import { ArticleCategoryAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/ArticleCategoryAlert';
import { ArticleTypeAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/ArticleTypeAlert';
import { CartItemErrorAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/CartItemErrorAlert';
import { IncompleteAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/IncompleteAlert';
import { PaymentMethodsAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/PaymentMethodsAlert';
import { TotalAlert } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/components/TotalAlert';
import { useCartAlerts } from '@/components/modules/Application/components/_shared/components/ApplicationSummary/components/CartAlerts/hooks/useCartAlerts';

export const CartAlerts = () => {
  const {
    showTotalAlert,
    showIncompleteAlert,
    showCartItemErrorAlert,
    showArticleTypeAlert,
    showArticleCategoryAlert,
    availablePaymentMethods,
  } = useCartAlerts();

  return (
    <>
      {showTotalAlert && <TotalAlert />}
      {showIncompleteAlert && <IncompleteAlert />}
      {showCartItemErrorAlert && <CartItemErrorAlert />}
      {showArticleTypeAlert && <ArticleTypeAlert />}
      {showArticleCategoryAlert && <ArticleCategoryAlert />}
      {availablePaymentMethods && <PaymentMethodsAlert {...availablePaymentMethods} />}
    </>
  );
};
